import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosGenericoAsync, cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { formatearLabel } from '../../funciones_globales/format';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { desformatearNumeroDecimal, formatearNumeroDecimal } from '../../funciones_globales/format';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const LabelSub = styled.label`
    font-weight: 200;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const Radio = styled.input`
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

class FormBanco01 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Willy20191111
            contador:0,
            //Global
            movimientoId: '',
            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
            estado: 'N', //N=>Nuevo, G => Guardado; 
            planVigente: null,
            ult_transaccion: null,
            num_diario: null,
            senae: '', //GASTO DE ADUANA IMPORTACION PAGADOS EN OPCION VARIOS
            fechaProceso: null,

            ctaParametroImp: null, //parametroCTAImp
            catRubroGastoImportacion: [],   //mbaquero
            catRubroGastoImportacion_sel: null,
            deshabilitaGasto: true,

            cod_proveedor: null,
            cod_empleado: null,
            SecuenciaCheque: null,

            //VALOR TOTAL POR MOVIMIENTO DE CAJACHICA
            valorMovCchica: null,
            
            //Reporte Cheque
            rptCheque: null,

            cuentaDeporpas: null,  //SU VALOR === null cuando la cuenta no tiene registrada una cuenta contable
            cuentaProveedor: null, //CUENTA CONTABLE PROVEEDOR
            cuentaAntProveedor: null, //CUENTA DE ANTICIPO DEL PROVEEDOR
            cuentaAntEmpleado: null,
            cuentaCaja_sel:  null,

            caja_sel: null,
            catCuentas: [], //catalogos a mostrar en combo cta bancaria
            catCuentas_sel: null, //cuenta bancaria seleccionada
            flujo_sel: null,
            optFlujo: [],

            cuentasBenf_sel: null,//Cuentas para beneficiario, opcion varios            
            importacion_sel: null,
            
            ident_prov:null,
            cedula: '',
            ident_emp:'',
            nombreProveedor:'',
            beneficiario:'',
            num_chq: '',
            valor_chq: '', //VALOR CHEQUE ->P
            concepto: '',

            valor_add: '',

            //Radio
            otras_opciones: null,
            opciones: 'P', //OPCION POR DEFECTO PROVEEDOR

            //catalogos            
            repCuentas: [], //Trae toda la informacion necesaria de las cuentas BANCARIAS
            repCtasCaja:[], //Trae cuentas asocuadas a las cajas
            
            //VALOR OBSERVACION
            observacionCuenta: '',

            //Tipo transaccion 10/01/2019
            tipoContable: 'D',

            //TotalGrid Op. VA
            totalCuentaDebe: 0,
            totalCuentaHaber: 0,

            //Opcion para activar cuentas (OP: P)
            activarCuentas: false,

            //Calculo de diferencia entre Debe & Haber
            difDebeHaber: 0,

            //Grids
            gridDocsPendientes: [],
            gridCuentasContables: [],
            gridDocsPagar: [],
            gridAnticipos: [],
            gridAnticiposEmpleado: [],
            coldefAnticiposEmpleado:[{  header: "",
                                        width: 30,                    
                                        checkboxSelection: true,
                                        suppressSorting: true,
                                        suppressMenu: true,
                                        suppressFilter: true,
                                        pinned: true                                                
                                    },
                                    {   header: "Cédula",
                                        field: "Cedula",
                                        width: 90,
                                        type: "string"
                                    },
                                    {   header: "Apellido",
                                        field: "Apellido",
                                        width: 100,
                                        type: "string"
                                    },                          
                                    {   header: "Nombre",
                                        field: "Nombre",
                                        width: 100,
                                        type: "string"
                                    },
                                    {   header: "Fecha",
                                        field: "Fecha",
                                        width: 75,
                                        type: "fecha"
                                    },
                                    {   header: "Concepto",
                                        field: "Concepto",
                                        width: 120,
                                        type: "string"                                 
                                    },
                                    {   header: "Valor",
                                        field: "Valor",
                                        width: 70,
                                        type: "num_decimal"                                 
                                    }],
            coldefAnticipos:[
                                {  header: "",
                                    width: 30,                    
                                    checkboxSelection: true,
                                    suppressSorting: true,
                                    suppressMenu: true,
                                    suppressFilter: true,
                                    pinned: true                                                
                                },
                                {   header: "Cédula",
                                    field: "CedulaRuc",
                                    width: 90,
                                    type: "string"
                                },
                                {   header: "Razón Social",
                                    field: "RazonSocial",
                                    width: 190,
                                    type: "string"
                                },
                                {   header: "Fecha",
                                    field: "Fecha",
                                    width: 80,
                                    type: "fecha"
                                },    
                                {   header: "Concepto",
                                    field: "Concepto",
                                    width: 120,
                                    type: "string"                                 
                                },                   
                                {   header: "Valor",
                                    field: "Valor",
                                    width: 70,
                                    type: "num_decimal"                                 
                                }
                            ],

            coldefDocsPagar:[
                                {  header: "N°",
                                    field: "Secuencia",
                                    width: 30,
                                    type: "num_entero"
                                },
                                {   header: "Fecha Fac.",
                                    field: "Fecha_FAC",
                                    width: 80,
                                    type: "fecha"
                                },
                                {
                                    header: "Fecha Ven.",
                                    field: "Fecha_VEN",
                                    width: 80,
                                    type: "fecha"
                                },                            
                                {   header: "Tipo",
                                    field: "Tipo",
                                    width: 40,
                                    type: "string"
                                },
                                {   header: "#. Doc.",
                                    field: "Num_Doc",
                                    width: 130,
                                    type: "string"
                                },
                                {   header: "Nom. Prov.",
                                    field: "Nom_Proveedor",
                                    width: 220,
                                    type: "string"
                                },
                                { header: "Saldo",
                                    field: "Saldo",
                                    width: 70,
                                    type: "num_decimal"
                                },
                                {   header: "Valor",
                                    field: "Valor_Pagar",
                                    width: 70,
                                    type: "num_decimal"                                 
                                },
                                {   header: "",
                                    field: "eliminar",
                                    width: 50,
                                    type: "link_elim"                                                
                                }
                            ],
            coldefCuentasContables:[
                {   header: "Cuenta",
                    field: "Cuenta",
                    width: 105,
                    type: "string"
                },
                {   header: "Nombre",
                    field: "Nombre",
                    width: 265,
                    type: "string"
                },
                {   header: "Cod.",
                    field: "codFlujo",
                    width: 40,
                    type: "string"
                },
                {   header: "Flujo",
                    field: "Flujo",
                    width: 60,
                    type: "string"
                },
                { header: "Tipo",
                    field: "DebeHaber",
                    width: 40,
                    type: "string"
                },
                { header: "Valor",
                    field: "Valor",
                    width: 70,
                    type: "num_decimal"
                },
                {   header: "Nombre Gasto",  /* mbaquero */
                field: "nombre_gasto",
                width: 110,
                type: "string"                                             
                },
                {   header: "CodigoGasto",  /* mbaquero */
                field: "codigoGasto",
                hide: true,
                type: "string"                                             
                },
                {   header: "",
                    field: "eliminar",
                    width: 50,
                    type: "link_elim"                                                
                },],
            coldefDocsPendientes: [
                                    {   header: "",
                                        width: 30,                    
                                        checkboxSelection: true,
                                        suppressSorting: true,
                                        suppressMenu: true,
                                        suppressFilter: true,
                                        pinned: true                                                
                                    },        
                                    { header: "N°",
                                    field: "Secuencia",
                                    width: 50,
                                    type: "num_entero"
                                    },
                                    { header: "Fecha Fac.",
                                    field: "Fecha_FAC",
                                    width: 105,
                                    type: "fecha"
                                    },
                                    {
                                    header: "Fecha Ven.",
                                    field: "Fecha_VEN",
                                    width: 80,
                                    type: "fecha"
                                    },                
                                    { header: "Tipo",
                                    field: "Tipo",
                                    width: 60,
                                    type: "string"
                                    },
                                    { header: "#. Doc.",
                                    field: "Num_Doc",
                                    width: 95,
                                    type: "string"
                                    },
                                    { header: "Saldo",
                                    field: "Saldo",
                                    width: 70,
                                    type: "num_decimal"
                                    },
                                    {   header: "Val Pagar",
                                        field: "Valor_Pagar",
                                        width: 70,
                                        type: "string",
                                        editable: true                                          
                                    }
                                ]
        };
        
        this.docsPendientesOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            singleClickEdit: true,
            enableColResize: true,
            enableFilter: true,
            enableSorting: true,
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{
                if(event.node.selected === true){                    
                    let seleccion = this.apidocsPendientes.getSelectedRows();
                    this.addDocumentoPendiente(seleccion[0]);
                }
            }),
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{                
                
                switch (event.colDef.field){
                    case "Valor_Pagar":
                        if(isNaN(event.data.Valor_Pagar)===true || event.data.Valor_Pagar===""){                            
                            event.data.Valor_Pagar = event.data.Saldo
                        }else{
                            var valor_editado = 0;
                            var saldo = 0;

                            valor_editado = parseFloat(event.data.Valor_Pagar);
                            saldo = parseFloat(event.data.Saldo);
                            if( (Math.round(valor_editado * 100 ) / 100) > (Math.round(saldo * 100)  / 100)){
                                event.data.Valor_Pagar = Math.round(saldo * 100 ) / 100;
                            }else{
                                event.data.Valor_Pagar = valor_editado;
                            }
                        }

                    break
                    default:
                    break
                }
                this.apidocsPendientes.refreshCells();
            }),
            onCellEditingStarted:((event)=> {})
        };

        //Se adicionan cuentas de beneficiarios
        this.CuentasContablesOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDataChanged:((event)=>{
            }),
            onCellValueChanged:((event)=>{  
            }),
            onCellEditingStarted:((event)=> {
            })
        };
        
        this.docsPagarOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDataChanged:((event)=>{
            }),
            onCellValueChanged:((event)=>{  
            }),
            onCellEditingStarted:((event)=> {
            })
        };

        //SELECCIONA LOS ANTICIPOS A PAGAR DE LOS CHEQUES (MONTO TOTAL SIEMPRE)
        this.anticiposOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:false,
            singleClickEdit: false,
            enableColResize: true,
            enableCellChangeFlash: true,
            enableFilter: true, 
            onRowSelected: ((event)=>{
                if(this.state.operacion === 'G'){
                    //AUMENTAR SALDO                        
                    let seleccion = this.apiAnticipo.getSelectedRows();
                    let acc = 0;
                    let proveedor = {};
                    seleccion.forEach((DATA)=>{
                        acc = acc + DATA.Valor;
                        proveedor.value = DATA.Proveedor?DATA.Proveedor:null;
                        proveedor.label = 'ANTICIPO'
                    })

                    this.setState({valor_chq: formatearNumeroDecimal(acc.toFixed(2)),
                    cedula: seleccion.length>0?seleccion[0].CedulaRuc:'', beneficiario: seleccion.length>0?seleccion[0].RazonSocial:'',
                    concepto: seleccion.length>0?seleccion[0].Concepto:'', ident_prov: proveedor}, ()=>{
                        if(event.node.selected === true && this.state.operacion === 'G'){
                            this.getProveedor();
                        }
                    }) 
                }else{
                    alert("Acción no permitida, si desea realizar cambios debe anular el movimiento y crear otro.")
                }                
            }),
            onRowDataChanged:((event)=>{})
        };

        //SELECCIONA LOS ANTICIPOS PENDIENTES DE LOS EMPLEADOS DE LA EMPRESA
        this.anticiposEmpleadoOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            singleClickEdit: true,
            enableColResize: true,
            enableCellChangeFlash: true,
            enableFilter: true, 
            onRowSelected: ((event)=>{
                if(this.state.operacion === 'G'){   
                    //Totalizacion Grid   
                                 
                    let seleccion = this.apiAnticipoEmpleado.getSelectedRows();
                    let acc = 0;

                    seleccion.forEach((DATA)=>{
                        acc = acc + DATA.Valor;
                    })

                    this.setState({valor_chq: formatearNumeroDecimal(acc.toFixed(2)),
                        ident_emp: seleccion.length>0?seleccion[0].Cedula:'', 
                        beneficiario: seleccion.length>0?seleccion[0].Nombre+' '+seleccion[0].Apellido:'',
                        concepto: seleccion.length>0?seleccion[0].Concepto:''}) 
                }else{
                    alert("Acción no permitida, si desea realizar cambios debe anular el movimiento y crear otro.")
                } 
            }),
            onRowDataChanged:((event)=>{})
        };

        this.actualizarCamposCheque = this.actualizarCamposCheque.bind(this);
        this.getProveedor = this.getProveedor.bind(this);
        this.getEmpleado = this.getEmpleado.bind(this);
        this.changeIdProveedor = this.changeIdProveedor.bind(this);
        this.changeCaja = this.changeCaja.bind(this);

        //OP
        this.addCuenta = this.addCuenta.bind(this);
        this.addDocumentoPendiente = this.addDocumentoPendiente.bind(this);
        this.validarNumCheque = this.validarNumCheque.bind(this);
        this.validarMontocheque = this.validarMontocheque.bind(this);
        this.validarMontoAdicion = this.validarMontoAdicion.bind(this);
        this.getOptions_CtaContable = this.getOptions_CtaContable.bind(this);
        this.validacionFlujo  = this.validacionFlujo.bind(this);
        this.guardarEmisionCheque = this.guardarEmisionCheque.bind(this);
        this.getChequesById = this.getChequesById.bind(this);
        this.anularEmisionCheque = this.anularEmisionCheque.bind(this);
        this.getDCajaChica = this.getDCajaChica.bind(this);
        this.impCheque = this.impCheque.bind(this);
        this.impRecibo = this.impRecibo.bind(this);
        this.importacion_sel = this.importacion_sel.bind(this);
        this.setObservacion = this.setObservacion.bind(this);
        this.validarTipoCuenta = this.validarTipoCuenta.bind(this);
        this.handleHabilitaGasto= this.handleHabilitaGasto.bind(this); //mbaquero

        //GRID
        this.onGridDocsPendientesReady = this.onGridDocsPendientesReady.bind(this);
        this.onGridCuentasContablesReady = this.onGridCuentasContablesReady.bind(this);
        this.onGridDocsPagarReady = this.onGridDocsPagarReady.bind(this);
        this.onGridAnticiposReady = this.onGridAnticiposReady.bind(this);
        this.onGridAnticiposEmpleadosReady = this.onGridAnticiposEmpleadosReady.bind(this);
    }

    // mbaquero
    handleHabilitaGasto(value)
    {
        console.log('Aqui llega')
        console.log(value)
        if (value !== null) 
             if (value.value.toString().trim() !== this.state.ctaParametroImp){
                this.setState({deshabilitaGasto: true})}
            else{
                this.setState({deshabilitaGasto: false})
        }
    }

    //OverControls
    actualizarCamposCheque(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });

        if(target.type ==='radio'){
            this.clear();
            this.clearIngCtasBeneficiario();
            this.setState({operacion: 'G'})
        }

        if(target.type ==='radio' && name==='opciones'){
            this.setState({otras_opciones: null, movimientoId: ''});
            //this.limpiarPantalla('A');
        }

        if(target.type ==='radio' && name==='opciones' && value==='O'){
            this.setState({otras_opciones: 'AP'}, ()=>{
                this.cargarOrdenPago('PRV')
            });
        }

        //CARGA DE DATOS ANTICIPOS

        //EMPLEADO
        if(target.type ==='radio' && value==='AE' ){
            this.cargarOrdenPago('EMP')
        }

        //Proveedor
        if(target.type ==='radio' && value==='AP'){
            this.cargarOrdenPago('PRV')
        }
    }

    cargarOrdenPago(ente){
        this.cargarObjetos('/ordenpago?ente='+ente+'&tipo=1').then((result)=>{
            if(result.length > 0){
                if(ente === 'PRV'){
                    var arrayPRV = [];
                    result.forEach((DATA)=>{
                        var item = {};
                        
                        item.idOrdenPago = DATA.idOrdenPago;
                        item.Ente = DATA.Ente;
                        item.CedulaRuc = DATA.prv!==null?DATA.prv.CedulaRuc:'';
                        item.RazonSocial = DATA.prv!==null?DATA.prv.RazonSocial:'';
                        item.Fecha = DATA.Fecha
                        item.Concepto = DATA.Concepto.toString().trim();
                        item.Valor =  DATA.Valor;
                        item.Proveedor = DATA.Proveedor;
                        item.idAnticipo = parseInt(DATA.IdAnticipo.toString().trim(), 10);
                        arrayPRV.push(item);
                    })
                    this.setState({gridAnticipos: arrayPRV})
                }else{

                    var arrayEMP = [];
                    result.forEach((DATA)=>{
                        var item = {};

                        item.idOrdenPago = DATA.idOrdenPago;
                        item.Ente = DATA.Ente;
                        item.Cedula = DATA.emp!==null?DATA.emp.Cedula:'';
                        item.Apellido = DATA.emp!==null?DATA.emp.Apellido:'';
                        item.Nombre = DATA.emp!==null?DATA.emp.Nombre:'';
                        item.Fecha = DATA.Fecha
                        item.Concepto = DATA.Concepto.toString().trim();
                        item.Valor =  DATA.Valor;
                        item.Empleado = DATA.Empleado.toString().trim();
                        item.idAnticipo = parseInt(DATA.IdAnticipo.toString().trim(), 10);
                        arrayEMP.push(item);
                    })

                    this.setState({gridAnticiposEmpleado: arrayEMP})
                }
            }else{
                alert("No existen registros a presentar")
            }
        })
    }

    changeIdProveedor(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        if(value.length <=20){
            if(isNaN(value)===false){
                this.setState({[name]: value});
            }
        } 
    }

    changeCuentaBancaria(value){        
        this.setState({cuentaDeporpas: null}, ()=>{

            this.setState({catCuentas_sel: value!==null?value.value:null})
            if(value!==null){
                this.validarcuentaBancaria(value.value);
            }
        })
    }

    //No esta el Siguiente esta el ultimo ingresado
    validarcuentaBancaria(value){
        var conCuenta = "";
        this.state.repCuentas.forEach((CUENTA)=>{
            if(CUENTA.Codigo === value){
                conCuenta = CUENTA.ConCuenta
                this.setState({SecuenciaCheque: CUENTA.SecuenciaCheque+1, num_chq: '',
                rptCheque: CUENTA.Rpt});
            }
        })

        if(conCuenta !== ""){
            this.setState({cuentaDeporpas: conCuenta})
        }else{            
            alert("La cuenta bancaria seleccionada no tiene una cuenta contable asignada")
        }
    }

    changeCaja(value){
        this.setState({cuentaCaja_sel:  null}, ()=>{
            this.setState({caja_sel: value!==null?value:null})
            if(value!==null){                
                var valor = value.label.toString().split("(");
                var valorSub = valor[1].toString().split(")");

                this.validarcuentaCaja(valorSub[0]);
            }
        })
    }

    validarcuentaCaja(value){        
        var conCuentaCaja = "";
        this.state.repCtasCaja.forEach((CUENTA)=>{
            if(CUENTA.Codigo === value){
                if(CUENTA.ConCuenta !== null){
                    conCuentaCaja = CUENTA.ConCuenta
                }
            }
        })
        if(conCuentaCaja !==""){
            this.setState({cuentaCaja_sel: conCuentaCaja})
        }else{            
            alert("La caja seleccionada no tiene una cuenta contable asignada")
        }
    }

    onGridDocsPendientesReady(params){
        this.apidocsPendientes = params.api;
        this.columnApiDocsPendientes = params.columnApi;
    }

    onGridCuentasContablesReady(params){
        this.apiCuentasContables = params.api;
        this.columnApiCuentasContables = params.columnApi;
    }

    onGridDocsPagarReady(params){
        this.apiDocsPagar = params.api;
        this.columnApiDocsPagar = params.columnApi;
    }

    onGridAnticiposReady(params){
        this.apiAnticipo = params.api;
        this.columnApiAnticipo = params.columnApi;
    }

    onGridAnticiposEmpleadosReady(params){
        this.apiAnticipoEmpleado = params.api;
        this.columnApiAnticipoEmpleado = params.columnApi;
    }

    validarNumCheque(){
        if(this.state.num_chq.toString().trim()!==""){
            if(this.state.num_chq.toString().trim() !== this.state.SecuenciaCheque.toString().trim()){
                alert("La secuencia ingresada no corresponde a la secuencia del banco "); //("+this.state.SecuenciaCheque+")
                this.setState({num_chq: ''});
            }
        }
    }

    limpiarPantalla(param){
        this.clear();
        this.clearIngCtasBeneficiario();
        this.setState({detCajaChica: [], caja_sel: null, tipoDoc_sel: null,observacion: '', operacion: 'G', 
        senae: '', totalCuentaDebe: 0, totalCuentaHaber: 0});
        
        if(param==='A'){
            this.setState({movimientoId: ''});
        }

        //SETEO DE OPERACION POR DEFECTO GUARDAR, Y ESTADO NUEVO
        this.setState({operacion: 'G', estado: 'N',contador:0})

        if(this.state.otras_opciones==='AE' ){
            this.cargarOrdenPago('EMP')
        }else if(this.state.otras_opciones==='AP'){
            this.cargarOrdenPago('PRV')
        }
    }

    validarMontocheque(){
        var valor = this.state.valor_chq;
        var newValue = 0;
        let valorReinicio = "0";
        
        //VALIDACION POR VALOR MENOR AL SELECCIONADO
        let valorchq = this.totalizarGrid(this.state.gridDocsPagar, 'Valor_Pagar');
        
        //Seteo Correcto para valor de reinicio
        if(this.state.opciones === 'P'){
            valorReinicio = valorchq
        }


        if(valor !== ""){
            newValue = desformatearNumeroDecimal(valor);
            valor = newValue;
        }
        
        if(isNaN(parseFloat(valor))===true || valor===""){
            this.setState({valor_chq: formatearNumeroDecimal(valorReinicio)});
        }else{            
            if(parseFloat(valor) <= 0){
                this.setState({valor_chq: formatearNumeroDecimal(valorReinicio)});
            }else{           
                if(valor >= valorchq.toFixed(2) && valorchq.toFixed(2) > 0 && this.state.opciones === 'P'){
                    
                    this.setState({valor_chq: formatearNumeroDecimal(valor)}, ()=>{
                        //VALIDACION POR CASO DE PAGO PROVEEDOR
                        let anteriorDebe = desformatearNumeroDecimal(this.state.totalCuentaDebe)
                        let debe  = this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D');
                        let haber = this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H');

                        //DIFERENCIA = (DEBE_ANTERIOR - DEBECONTABLE) - ValorChq; 
                        let dif = Math.round(((anteriorDebe - debe) - valor)*100)/100;    
                        
                        //DEBE REAL = DEBE CTAS + ValorCHq + (DIF) 
                        debe = valor + dif + debe;

                        //HABER REAL = ValorChq + HABER CTS
                        haber = valor + haber;

                        this.setState({totalCuentaDebe: formatearNumeroDecimal(debe), totalCuentaHaber: formatearNumeroDecimal(haber),
                        difDebeHaber: dif})

                        console.log('DEBE ANT: ',anteriorDebe ,' DIFERENCIA: ', dif, 'DEBE: ', debe, 'Haber: ', haber) 
                    })
                }else if(this.state.opciones === 'P'){
                    console.log('Correccion')
                    this.setState({valor_chq: formatearNumeroDecimal(valorReinicio)})
                }else if(this.state.opciones !== 'P'){                    
                    console.log('Fuera opcion proveedor..')
                    this.setState({valor_chq: formatearNumeroDecimal(valor)})
                }
            }
        }
    }

    validarMontoAdicion(){
        var valor = this.state.valor_add;
        var newValue = 0;

        if(valor !== ""){
            newValue = desformatearNumeroDecimal(valor);
            valor = newValue;
        }
        
        if(isNaN(parseFloat(valor))===true || valor===""){
            this.setState({valor_add: ''});
        }else{
            //Validacion valor
            if(parseFloat(valor) <= 0){
                this.setState({valor_add: ''});
            }else{
                this.setState({valor_add: formatearNumeroDecimal(valor)})
            }
        }
    }

    //Operaciones
    getProveedor(){
        //AP OPCION ANTICIPO PROVEEDOR
        //AE OPCION ANTICIPO EMPLEADO

        if(this.state.ident_prov !== null){
            var data = {}
            var cuenta = "";
            var ctaAnticipo = "";
            var cod_proveedor = "";
            data.Tipo = 'F'

            this.cargarObjetos('/proveedores?tipo=indt_proveedor&ident='+this.state.ident_prov.value).then((result)=>{
                if(result.length > 0){
                    //WILLY CEDEÑO 20191018
                    if(result[0].Tipo==='S'){   
                        cuenta=result[0].CuentaContableServicio;

                    }else{
                        cuenta = result[0].Cuenta;
                    }
                    this.setState({nombreProveedor: result[0].Descripcion, cod_proveedor: result[0].Codigo,
                    cuentaProveedor: cuenta, beneficiario: result[0].Descripcion})
                
                    cod_proveedor=result[0].Codigo;
                    ctaAnticipo = result[0].Cuenta_anticipo?result[0].Cuenta_anticipo.toString().trim():null;
                    //Proceso de cuenta de anticipo
                    if(ctaAnticipo!==null && this.state.otras_opciones==='AP'){
                        if(ctaAnticipo !=="" && this.state.otras_opciones==='AP'){
                            this.cargarCuentasContables(ctaAnticipo.toString().trim(),this.state.planVigente).then((r_ctaAnticipo)=>{
                                if(r_ctaAnticipo===null && this.state.otras_opciones==='AP'){
                                    this.setState({cuentaAntProveedor: null})
                                    alert("La cuenta de anticipo no se encuentra registrada en el sistema");

                                }else if(this.state.otras_opciones==='AP'){
                                    this.setState({cuentaAntProveedor: r_ctaAnticipo.Cuenta})
                                }
                            })
                        }else{
                            if(this.state.otras_opciones==='AP'){
                                alert("El proveedor Seleccionado no posee cta de anticipo")
                                this.clear();
                            }
                        }
                    }else{
                        if(this.state.otras_opciones==='AP'){
                            alert("El proveedor seleccionado no posee cta. de anticipo")
                            this.clear();
                        }
                    }
                    
                    //Proceso de cuenta de Contable Y CARGAR GRID DE DOCUMENTOS
                    if(cuenta!==null && this.state.opciones==='P'){
                        if(cuenta.toString().trim()!==""){
                            this.cargarCuentasContables(cuenta.toString().trim(),this.state.planVigente).then((r_ctaContable)=>{
                                if(r_ctaContable===null){
                                    this.setState({nombreProveedor: '', cod_proveedor: null,
                                        cuentaProveedor: null, beneficiario: ''}, ()=>{
                                            alert('Proveedor no tiene cuenta asociada al plan contable actual: '+this.state.planVigente);
                                        })
                                }else{                                    
                                    this.setState({cuentaProveedor: r_ctaContable.Cuenta})                              
                                    this.cargarObjetos('/compras?proveedor='+cod_proveedor+'&status=P&status=E&msaldo=0&debito=N&order=desc').then((result_docs)=>{
                                        //'/compras?proveedor='+cod_proveedor+'&tipo=F&tipo=L&status=P&status=E&msaldo=0&debito=N&order=desc'
                                        var arrayDocs = [], docsProcesados = [];
                                        arrayDocs = result_docs;

                                        if(result_docs.length>0){
                                            arrayDocs.forEach((DATA, i)=>{
                                            
                                                var item = {};
                                                item.Secuencia = i+1;
                                                item.Fecha_FAC = DATA.Fecha;
                                                item.Fecha_VEN = DATA.FechaVencimiento;
                                                //item.Tipo = DATA.Tipo!==null?(DATA.Tipo==='F'?'FAC':'LQC'):'';
                                                item.Tipo = DATA.Tipo!==null?(DATA.Tipo.trim()):'';
                                                item.Num_Doc = DATA.Establecimiento.toString().trim()+''+DATA.PuntoVenta.toString().trim()+'-'+DATA.Factura.toString().trim()
                                                item.Saldo = DATA.Saldo.toFixed(2); 
                                                item.Valor_Pagar = item.Saldo;
                                                item.Compra = DATA.Compra;
                                                docsProcesados.push(item);
                                            })
                                            this.setState({gridDocsPendientes: docsProcesados})
                                        }else{
                                            alert("El proveedor no tiene documentos pendientes")
                                        }                                       
                                    })
                                }                                
                            })
                        }else{
                            if(this.state.otras_opciones==='P'){
                                alert("El proveedor Seleccionado no posee cta de contable")
                                this.clear();
                            }
                        }
                    }else{
                        //WILLY CEDEÑO 20191018
                        if(this.state.otras_opciones===null && cuenta===null){
                            alert('El proveedor Seleccionado no posee cta de contable')
                        }
                        if(this.state.otras_opciones==='P'){
                            alert("El proveedor Seleccionado no posee cta de contable")
                            this.clear();
                        }
                    }

                }else{
                    this.setState({ident_prov:null}, ()=>{
                        if(result.length <= 0 && this.state.ident_prov===null){
                            alert('No existen coincidencias con el número de cédula ingresado');
                        }
                    })
                }
            })
        }else{
            this.setState({nombreProveedor: '', cod_proveedor: null,
                cuentaProveedor: null, beneficiario: '',
                gridDocsPendientes: []
            })
        }
    }

    getEmpleado(){
        if(this.state.ident_emp !== ""){
            var ctaAntEmpleado = "";
            var cod_empleado = "";
            
            this.cargarObjetos('/empleados?cedula='+this.state.ident_emp).then((result)=>{
                if(result.length > 0){
                    //Setea datos del empleado
                    this.setState({beneficiario: result[0].Nombre+' '+result[0].Apellido, cod_empleado: result[0].Empleado,
                        cuentaAntEmpleado: result[0].CuentaPrestamo/*, beneficiario: result[0].Nombre+' '+result[0].Apellido*/})
    
                        cod_empleado = result[0].Empleado;
                        ctaAntEmpleado = result[0].CuentaPrestamo
                        
                        if(ctaAntEmpleado!==null){
                            if(ctaAntEmpleado.toString().trim()!==""){
                                this.cargarCuentasContables(ctaAntEmpleado.toString().trim(),this.state.planVigente).then((r_ctaAnticipo)=>{
                                    if(r_ctaAnticipo===null){
                                        this.setState({cuentaAntEmpleado: null})
                                        alert("La cuenta ingresada no se encuentra registrada en el sistema");
                                    }else{
                                        //Cargar el grid AnticiposEmpleado
                                        this.cargarObjetos('/anticiposporempleado?empleado='+cod_empleado).then((resul_anticipoEmpleado)=>{
                                            this.setState({cuentaAntEmpleado: r_ctaAnticipo.Cuenta})
                                            var arrayConsultado = [], arrayFormateado = [];
                                            arrayConsultado = resul_anticipoEmpleado;

                                            if(resul_anticipoEmpleado.length > 0){
                                                arrayConsultado.forEach((DATA,i)=>{
                                                    var item = {};
                                                    item.Secuencia = i+1;
                                                    item.Fecha = DATA.FechInipago;
                                                    item.Observacion = DATA.Observacion;
                                                    item.Valor = DATA.Monto;
                                                    item.N_Anticipo = DATA.N_Anticipo;
                                                    item.Empresa = DATA.Empresa;
    
                                                    arrayFormateado.push(item);
                                                })
                                                this.setState({gridAnticiposEmpleado: arrayFormateado, concepto: arrayConsultado[0].Observacion})                                                
                                            }else{
                                                alert("El empleado "+cod_empleado+" no tiene anticipos pendientes")
                                            }                                           
                                        })
                                    }
                                })
                            }
                        }else{
                            alert("El empleado seleccionado no posee cta. de prestamo")
                            this.clear();
                        }
                }else{
                    this.setState({ident_emp:""}, ()=>{
                        if(result.length <= 0 && this.state.ident_emp===""){
                            alert('No existen coincidencias con el número de cédula ingresado');
                        }
                    })
                }
            })
        }
    }

    getChequesById(){
        if(this.state.movimientoId === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.movimientoId,10) <= 0 ){
            alert("Movimiento no válido");
            this.clear();
        }else{
            global_axios({
                method: 'GET',
                url: '/movimientosbanco/'+this.state.movimientoId.toString()
            })
            .then((response)=>{                
                var loadData = response.data;
                console.log('RESPUESTA: ', loadData);

                if(loadData.Tipo==='CHE'){                    
                    if(loadData.Cuenta!==null && loadData.Cuenta!==""){
                        this.setState({catCuentas_sel: loadData.Cuenta}, ()=>{
                            this.validarcuentaBancaria(loadData.Cuenta)
                        })
                    }
                    //Seteo de estado
                    this.setState({operacion: 'M', estado: 'G' , fechaProceso: moment(loadData.Fecha,'DD/MM/YYYY')})
                    loadData.Operacion = loadData.Operacion?loadData.Operacion.trim():''
                    
                    //CARGA DE OPERACION
                    if(loadData.Operacion === 'P'){
                        this.setState({opciones :loadData.Operacion.trim(), activarCuentas: loadData.ActivarCuentas})
    
                        //PROCESO PARA CARGAR DATOS GENERALES DE MOVBANCO
                        this.cargarDatosGenerales(loadData);
    
                        //CARGAR GRID FACTURAS A PAGAR (DPDMovBanco)
                        this.cargarObjetos('/pagos/'+this.state.movimientoId).then((result)=>{
                            
                            let docPorPagar = this.cargarDPDMovBanco(result);
                            //console.log('DPDMovBanco: ', docPorPagar)
                            
                            let ArrayPagos = [];
                            let ArrayCtas = [];
                            //Separacion de CUTAS Y PAGOS
                            docPorPagar.forEach((DATA, i)=>{
                                if(DATA.hasOwnProperty('Cuenta') === true){
                                    ArrayCtas.push(DATA);
                                }else if(DATA.hasOwnProperty('Compra') === true){
                                    ArrayPagos.push(DATA);
                                }
                            })

                            //Totalizacion de Movimiento
                            let haber = this.state.totalCuentaHaber
                            haber = haber + parseFloat(this.state.valor_chq);

                            this.setState({gridDocsPagar: ArrayPagos,
                                gridCuentasContables: ArrayCtas, 
                                totalCuentaDebe: formatearNumeroDecimal(haber), 
                                totalCuentaHaber: formatearNumeroDecimal(haber)
                            })
                        })
    
                    }else{
                        this.setState({opciones: 'O', otras_opciones: loadData.Operacion.trim()})
    
                        //PROCESO PARA CARGAR DATOS GENERALES DE MOVBANCO
                        this.cargarDatosGenerales(loadData);
    
                        if(loadData.Operacion === 'AP'){
                            this.cargarObjetos('/ordenpago?movbanco='+this.state.movimientoId).then((resultAntP)=>{
                                var cedula = "";
                                var arrayFormateado = [];
                                resultAntP.forEach((DATA, i)=>{
                                    var item = {};
                                    
                                    item.idOrdenPago = DATA.idOrdenPago;
                                    item.Ente = DATA.Ente;
                                    if(DATA.prv!==null){
                                        cedula = DATA.prv.CedulaRuc
                                    }
                                    item.CedulaRuc = cedula
                                    item.RazonSocial = DATA.prv!==null?DATA.prv.RazonSocial:'';
                                    item.Fecha = DATA.Fecha
                                    item.Concepto = DATA.Concepto.toString().trim();
                                    item.Valor =  DATA.Valor;
                                    item.Proveedor = DATA.Proveedor;
                                    item.idAnticipo = parseInt(DATA.IdAnticipo.toString().trim(), 10);
    
                                    arrayFormateado.push(item);
                                   
                                })
                                if(loadData.provDet!==null){
                                    this.setState({ident_prov: loadData.provDet.CedulaRuc, cedula:cedula})
                                }
                                this.setState({gridAnticipos: arrayFormateado, cedula:cedula})
                            })
                            .catch((error)=>{                
                                alert(error.response?error.response.data.msg:error.message);      
                            });
                        }else if(loadData.Operacion === 'AE'){
                            this.cargarObjetos('/ordenpago?movbanco='+this.state.movimientoId).then((resultAntEmp)=>{
                                var arrayFormateado = [];
                                var cedula = "";
                                resultAntEmp.forEach((DATA,i)=>{
                                    var item = {};
    
                                    item.idOrdenPago = DATA.idOrdenPago;
                                    item.Ente = DATA.Ente;
                                    if(DATA.emp!==null){
                                        cedula = DATA.emp.Cedula
                                    }
                                    item.Cedula = cedula
                                    item.Apellido = DATA.emp!==null?DATA.emp.Apellido:'';
                                    item.Nombre = DATA.emp!==null?DATA.emp.Nombre:'';
                                    item.Fecha = DATA.Fecha
                                    item.Concepto = DATA.Concepto.toString().trim();
                                    item.Valor =  DATA.Valor;
                                    item.Empleado = DATA.Empleado.toString().trim();
                                    item.idAnticipo = parseInt(DATA.IdAnticipo.toString().trim(), 10);
    
                                    arrayFormateado.push(item);
                                })
                                this.setState({gridAnticiposEmpleado: arrayFormateado, ident_emp: cedula})
    
                                if(loadData.empDet!==null){
                                    this.setState({ident_emp: loadData.empDet.Cedula})
                                }
                            })
                            .catch((error)=>{                
                                alert(error.response?error.response.data.msg:error.message);      
                            });
                        }else if(loadData.Operacion === 'RC'){
                            if(loadData.CajaChica!==null){
    
                                this.cargarObjetos('/caja/cajachica?cadena_busq='+loadData.CajaChica.toString().trim()+'&carga=S').then((resultCaj)=>{
                                    var CajaChica = {};
                                    CajaChica.value = resultCaj[0].Codigo;
                                    CajaChica.label = resultCaj[0].Descripcion+' ('+resultCaj[0].Codigo+')';
    
                                    this.setState({caja_sel: CajaChica})
                                })
                                .catch((error)=>{                
                                    alert(error.response?error.response.data.msg:error.message);      
                                });
                            }
    
                        }else if(loadData.Operacion === 'VA'){
    
                            if(loadData.ImportacionGasto!==null){
                                this.cargarObjetos('/importaciones?cadena_busq='+loadData.ImportacionGasto.trim()).then((resultImp)=>{
                                    
                                    var importacion = {};
                                    importacion.value = resultImp[0].Codigo;
                                    importacion.label = resultImp[0].Codigo+' ('+resultImp[0].Descripcion+')';
                                    this.setState({importacion_sel: importacion}, ()=>{
                                        this.importacion_sel();
                                    })
                                })
                                .catch((error)=>{
                                    alert(error.response?error.response.data.msg:error.message);      
                                });
                            }
    
                            //CARGA DETALLE DEL GRID
                            console.log ('Aqui ingresa')
                            this.cargarObjetos('/pagos/pagos-varios/'+this.state.movimientoId).then((result)=>{
                                var gridCuentas = this.cargarDPDMovBanco(result);  
                                console.log(gridCuentas)  
                                this.setState({gridCuentasContables: gridCuentas})
                            })
                            .catch((error)=>{   
                                alert(error?error:'Error');      
                            });
                        }                    
                    }

                }else{
                    alert('- Movimiento no corresponde a una emisión de cheque')
                }
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    cargarDatosGenerales(loadData){
        this.setState({valor_chq: formatearNumeroDecimal(loadData.ValorProveedor.toFixed(2)),
            beneficiario: loadData.Beneficiario,
            num_chq: parseInt(loadData.Referencia, 10),
            concepto: loadData.Concepto,})
    }

    cargarDPDMovBanco(arrayEntrante){
        let acc = 0;
        var docsProcesados = [];        
        let totalDebe=0;
        arrayEntrante.forEach((DATA, i)=>{
            console.log('FILA: ',DATA, 'COMPARACION: ', DATA.compraDet !== null)
            if(DATA.compraDet !== null && DATA.compraDet !== undefined){
                console.log("DENTROO")
                //CASO PROVEEDORES
                let item = {};
                item.Secuencia = i+1;
                item.Fecha_FAC = DATA.compraDet.Fecha;
                item.Fecha_VEN = DATA.compraDet.FechaVencimiento;
                //item.Tipo = DATA.compraDet.Tipo!==null?(DATA.compraDet.Tipo.trim()==='F'?'FAC':'LQC'):'';
                item.Tipo = DATA.compraDet.Tipo!==null?(DATA.compraDet.Tipo.trim()):'';
                item.Num_Doc = DATA.compraDet.Establecimiento.toString().trim()+''+DATA.compraDet.PuntoVenta.toString().trim()+'-'+DATA.compraDet.Factura.toString().trim()
                item.Nom_Proveedor = DATA.compraDet.proveedorDet!==null?DATA.compraDet.proveedorDet.RazonSocial:'N/A'
                item.Saldo = DATA.compraDet.Saldo.toFixed(2); 
                item.Valor_Pagar = DATA.Valor!==null?DATA.Valor!==""?DATA.Valor:0:0;
                item.Compra = DATA.Compra;
                docsProcesados.push(item);
            }else{
                console.log(arrayEntrante)
                //CASO VARIOS
                if(DATA.cuentaDet!==null){
                    let item = {};
                    item.Cuenta = DATA.Cuenta.trim();
                    item.Nombre = DATA.cuentaDet.Nombre.trim();  //DATA.cuentaDet.Nombre.trim()
                    item.Valor = DATA.Valor;
                    if(DATA.DebeHaber){
                        item.DebeHaber = DATA.DebeHaber
                    }
                    // if(DATA.flujoDet!==null){
                    //     item.Flujo = DATA.flujoDet.Descripcion.trim();
                    //     item.codFlujo = DATA.Flujo.trim();
                    // }
                    item.Flujo = "";
                    item.codFlujo = "";
                    if(DATA.DebeHaber === 'H'){
                        acc = acc + parseFloat(DATA.Valor);
                    }else{
                        totalDebe= totalDebe + parseFloat(DATA.Valor);
                    }
                    //Rtoala 2019-06-14
                     if (DATA.CodigoGastoImp !== null) {
                         item.nombre_gasto = DATA.gastoImp.DESCRIPCION.trim();
                         item.CodigoGastoImp = DATA.CodigoGastoImp;
                     }      
                    docsProcesados.push(item);
                }
            }
        })
        console.log('DOC PROCESADOS: ',docsProcesados)
        console.log('ACC: ', acc)
        this.setState({totalCuentaHaber: Math.round(acc*100)/100 , 
            totalCuentaDebe: Math.round(totalDebe*100)/100})
        return docsProcesados;
    }

    cargarCuentasContables(cuenta, plan){
        return new Promise((resolve, reject) => {
            //CUENTA + PLANVIGENTE
            global_axios.get('/cuentas/'+cuenta+'/'+plan)
            .then((response)=>{                
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    getOptions_CtaContable(input, callback){
        /* /cuentas?cadena_busq=52.02.20.12&dep=001 FILTRO POR DEPARTAMENTO*/ 
        //let cadena_busq = '?cadena_busq='+ input+'&plan='+this.state.planVigente.toString();
        
        if (input.toString().length >= 2 ){            
            let cadena_busq = '?cadena_busq='+ input+'&dep='+this.props.departamento;
            cargarCatalogosGenericoAsyncInvertido('/cuentas', cadena_busq, callback)
        }
    }

    getOptions_CajaChica(input, callback){
        if (input.toString().length >= 1 ){
            let cadena_busq = '?cadena_busq='+ input;
            cargarCatalogosGenericoAsync('/caja/cajachica', cadena_busq, callback)
        }
    }
    
    validacionFlujo(value){
        this.setState({cuentasBenf_sel: value!== null?value:null,
            optFlujo: [], flujo_sel: null, observacionCuenta: ""},()=>{
            if(value){
                //this.setObservacion(value);
                var cuenta = value.value;
                var plan = this.state.planVigente;
                this.cargarCuentasContables(cuenta, plan).then((data)=>{
                    
                    if(data.Flujo === 'S'){
                        this.cargarObjetos('/flujos?cuenta='+cuenta).then((flujos)=>{
                            if(flujos.length > 1){
                                this.setState({optFlujo: flujos})
                            }
                        })
                    }
                })
            }
        })
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{

                reject('No existe movimiento a presentar...');
            });
        });
    }

    //Opcion a consultar , Nombre del state a guardar
    cargarCatalogosOtrosCatchResult(tipo, name) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                this.setState({[name]: response.data});
                resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase().trim()}-${item.Numero} (${item.Codigo.toString().toUpperCase()})` })));
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }
    
    cargarOtrosCatchResult(tipo, name){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                //Catura la respuesta y la devuelve
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }
    
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    addDocumentoPendiente(fila){
        if(this.addFacturaSinRepetir(fila)===false){
            if(parseFloat(fila.Valor_Pagar)>0){
                var item = {}
    
                item.Secuencia = fila.Secuencia;
                item.Fecha_FAC = fila.Fecha_FAC;
                item.Fecha_VEN = fila.Fecha_VEN;
                item.Tipo = fila.Tipo;
                item.Num_Doc = fila.Num_Doc;
                item.codProveedor = this.state.cod_proveedor;
                item.Compra = fila.Compra
                item.Cuenta = this.state.cuentaProveedor;
                item.Nom_Proveedor = this.state.nombreProveedor;
                item.Saldo = parseFloat(fila.Saldo);
                item.Valor_Pagar = parseFloat(fila.Valor_Pagar);
                
                this.setState({ gridDocsPagar: this.immutablePush(this.state.gridDocsPagar, item)}
                , ()=>{
                    let dif = this.state.difDebeHaber;
                    let valorchq = this.totalizarGrid(this.state.gridDocsPagar, 'Valor_Pagar');
                    valorchq = valorchq - dif;
                    let debe  = valorchq + dif + this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D');
                    let haber = valorchq + this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H');

                    console.log('DIFERENCIA: ', dif, 'ValorChq: ', valorchq, 'Debe: ', debe, 'Haber: ', haber)

                    this.setState({valor_chq: formatearNumeroDecimal(valorchq),
                    totalCuentaDebe: formatearNumeroDecimal(debe),
                    totalCuentaHaber: formatearNumeroDecimal(haber)})
                })
            }else{
                alert("- Seleccione facturas con valor a pagar mayor a 0")
            }
        }else{
            alert("- La Factura ya se encuentra agregada")
        }
    }

    addFacturaSinRepetir(fila){
        var result = false;
        this.state.gridDocsPagar.forEach((DATA)=>{
            if(fila.Num_Doc === DATA.Num_Doc && this.state.ident_prov.value === DATA.codProveedor){
                result = true;
            }
        })

        return result
    }

    totalizarGrid(grid, name){
        var acc = 0;

        grid.forEach((DATA)=>{
            acc = acc + parseFloat(DATA[name]);
        })
        return acc
    }

    totalizarCuentasContables(grid, name, tipo){
        //Adicion de funcion que evalua segun el tipo
        let valor = 0;
        let acumulador =0;
       console.log("ESTOY EN EL METODO CON TIPO "+ tipo);
       console.log(grid);
        grid.forEach((DATA)=>{
            let tipoData = DATA.DebeHaber.toString().toUpperCase().trim();
            if(tipoData===tipo){
                acumulador=acumulador+1
                console.log("Entrada tipo "+ tipo + "Numero "+ acumulador)
                console.log(DATA)
                valor  += parseFloat(DATA[name]);
                console.log(valor)
            }
        })
        console.log(valor)
        return valor
    }
    
    methodFromParent(id, datos_fila){
        console.log('FILA ENVIADA: ', datos_fila)
        if(this.state.operacion==='G'){
            var mensaje;
            mensaje = window.confirm("¿Desea eliminar el registro?"); 
            
            if (mensaje){
                if(datos_fila.hasOwnProperty('Nom_Proveedor')===true){
                    this.eliminarDocxPagar(datos_fila ,id) 
                }

                if(datos_fila.hasOwnProperty('DebeHaber')===true){
                    this.eliminarCtasBeneficiario(datos_fila ,id) 
                }
            }
        }else if(this.state.operacion==='M'){
            if(this.state.otras_opciones==='VA'){

                mensaje = window.confirm("¿Desea eliminar el registro?"); 
                if (mensaje){
                    if(datos_fila.hasOwnProperty('DebeHaber')){
                        this.eliminarCtasBeneficiario(datos_fila ,id) 
                    }
                }
            }else{
                alert("No se permite eliminar este item, si desea modificar anule y vuelva a generar otra emisión")
            }
            
        }
    }

    eliminarDocxPagar(datos_fila ,id){
        console.log('ENTRO A ELIMINAR DOCS POR PAGAR...')
        this.setState({ gridDocsPagar: this.immutableDelete(this.state.gridDocsPagar, id)},
        () =>{
                
                let valorchq = this.totalizarGrid(this.state.gridDocsPagar, 'Valor_Pagar');
                let dif = valorchq>0?this.state.difDebeHaber:0;
                valorchq = valorchq - dif;
                let debe  = valorchq + dif + this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D');
                let haber = valorchq + this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H');
                console.log('VALOR A PAGAR: ', valorchq)
                console.log('DEBE: ', debe)
                console.log('HABER: ', haber)
                console.log('DIFERENCIA: ', dif)

                this.setState({valor_chq: formatearNumeroDecimal(valorchq),
                    totalCuentaDebe: formatearNumeroDecimal(debe), totalCuentaHaber: formatearNumeroDecimal(haber)
                }, ()=>{
                    if(valorchq === 0){
                        this.setState({difDebeHaber: dif})
                    }
                })
            }
        )
    }

    eliminarCtasBeneficiario(datos_fila ,id){
        console.log('ENTRO A ELIMINAR CTAS BENEFICIARIO...')
        this.setState({ gridCuentasContables: this.immutableDelete(this.state.gridCuentasContables, id)},
        ()=>{
            let dif = this.state.difDebeHaber;
            let cheque = desformatearNumeroDecimal(this.state.valor_chq)
            let debe  = cheque + dif + this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D');
            let haber = cheque +this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H');
            this.setState({totalCuentaDebe: formatearNumeroDecimal(debe), totalCuentaHaber: formatearNumeroDecimal(haber)})
        })
    }

    addCuenta(){        
        if(this.state.cuentasBenf_sel!==null && this.state.valor_chq!=="" && this.state.valor_add!=="" && this.state.observacionCuenta!=="" && this.state.tipoContable!==""){
            var item = {};
            if(this.state.cuentasBenf_sel.value === this.state.ctaParametroImp)
            {  
                if(this.state.catRubroGastoImportacion_sel !== null){
                    let cheque = 0
                    let debe  = 0
                    let haber = 0
                    
                    console.log('OPERACION: ', this.state.opciones)
                    switch (this.state.opciones){
                        case 'P':
                            console.log('PROVEEDOR....')
                            let dif = this.state.difDebeHaber;
                            cheque = desformatearNumeroDecimal(this.state.valor_chq)
                            debe  = cheque + dif +this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D');
                            haber = cheque + this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H');

                            console.log('DIFERENCIA: ', dif, 'ValorChq: ', cheque, 'Debe: ', debe, 'Haber: ', haber)


                            if(this.state.tipoContable==='D'){
                                debe = Math.round((debe + desformatearNumeroDecimal(this.state.valor_add))*100)/100;
                            }else{
                                haber = Math.round((haber + desformatearNumeroDecimal(this.state.valor_add))*100)/100;
                            } 

                            console.log('AFECTACION DEBE: ', debe, 'AFECTACION HABER: ', haber)
                            break;
                        case 'O':
                            if(this.state.otras_opciones === 'VA'){
                                console.log('VARIOS....')
                                cheque = desformatearNumeroDecimal(this.state.valor_chq)
                                debe  = this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D');
                                haber = cheque +this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H');

                                if(this.state.tipoContable==='D'){
                                    debe = Math.round((debe + desformatearNumeroDecimal(this.state.valor_add))*100)/100;
                                }else{
                                    haber = Math.round((haber + desformatearNumeroDecimal(this.state.valor_add))*100)/100;
                                }
                            }              
                            break;
                    
                        default:
                            break;
                    }

                    if(this.state.optFlujo.length > 0 && this.state.flujo_sel === null){
                        alert("Seleccione un flujo para esta cuenta")
                    }else{
                        
                        
                        item.Cuenta = this.state.cuentasBenf_sel.value;
                        item.Nombre = String(this.state.observacionCuenta).toUpperCase();
                        
                        if(this.state.flujo_sel!==null){
                            item.codFlujo = this.state.flujo_sel.value;
                            item.Flujo =  formatearLabel(this.state.flujo_sel.label);
                        }
                        item.DebeHaber = this.state.tipoContable.toUpperCase();
                        item.Valor =  desformatearNumeroDecimal(this.state.valor_add);

                        console.log('DEBE: ', debe, 'HABER: ', haber)

                        item.nombre_gasto = null; item.CodigoGastoImp = null;

                        if (this.state.catRubroGastoImportacion_sel !== null)
                        {
                            var ultchar='';
                            let arrayValidacion= this.state.catRubroGastoImportacion_sel.label.split(" (");
                            if(arrayValidacion.length>2){
                                let nombreGasto = this.state.catRubroGastoImportacion_sel.label.split(" (");
                                item.nombre_gasto=nombreGasto[0].toString().trim();
                                ultchar= nombreGasto[arrayValidacion.length-1].replace(')','');
                                item.CodigoGastoImp = ultchar.trim();
                            }else{
                                let nombreGasto = this.state.catRubroGastoImportacion_sel.label.split(" (");
                                item.nombre_gasto = nombreGasto[0].toString().trim();
                                ultchar = nombreGasto[1].replace(')','');
                                item.CodigoGastoImp = ultchar.trim();
                            }
                            
                        }

                        this.setState({ gridCuentasContables: this.immutablePush(this.state.gridCuentasContables, item),  
                            totalCuentaDebe: formatearNumeroDecimal(debe), totalCuentaHaber: formatearNumeroDecimal(haber)
                        },()=>{
                            this.clearIngCtasBeneficiario(); 
                        })
                    }
                }else{
                    alert('Ingrese cuenta de gasto importacion')
                }
                
            }else {
                
                let cheque = 0
                let debe  = 0
                let haber = 0
                
                console.log('OPERACION: ', this.state.opciones)
                switch (this.state.opciones){
                    case 'P':
                        console.log('PROVEEDOR....')
                        let dif = this.state.difDebeHaber;
                        cheque = desformatearNumeroDecimal(this.state.valor_chq)
                        debe  = cheque + dif +this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D');
                        haber = cheque + this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H');

                        console.log('DIFERENCIA: ', dif, 'ValorChq: ', cheque, 'Debe: ', debe, 'Haber: ', haber)


                        if(this.state.tipoContable==='D'){
                            debe = Math.round((debe + desformatearNumeroDecimal(this.state.valor_add))*100)/100;
                        }else{
                            haber = Math.round((haber + desformatearNumeroDecimal(this.state.valor_add))*100)/100;
                        } 

                        console.log('AFECTACION DEBE: ', debe, 'AFECTACION HABER: ', haber)
                        break;
                    case 'O':
                        if(this.state.otras_opciones === 'VA'){
                            console.log('VARIOS....')
                            cheque = desformatearNumeroDecimal(this.state.valor_chq)
                            debe  = this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D');
                            haber = cheque +this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H');

                            if(this.state.tipoContable==='D'){
                                debe = Math.round((debe + desformatearNumeroDecimal(this.state.valor_add))*100)/100;
                            }else{
                                haber = Math.round((haber + desformatearNumeroDecimal(this.state.valor_add))*100)/100;
                            } 
                        }              
                        break;
                
                    default:
                        break;
                }

                if(this.state.optFlujo.length > 0 && this.state.flujo_sel === null){
                    alert("Seleccione un flujo para esta cuenta")
                }else{
                    item.Cuenta = this.state.cuentasBenf_sel.value;
                    item.Nombre = String(this.state.observacionCuenta).toUpperCase(); 
                    item.nombre_gasto = null;
                    item.CodigoGastoImp = null;
                    if(this.state.flujo_sel!==null){
                        item.codFlujo = this.state.flujo_sel.value;
                        item.Flujo =  formatearLabel(this.state.flujo_sel.label);
                    }
                    item.DebeHaber = this.state.tipoContable.toUpperCase();
                    item.Valor =  desformatearNumeroDecimal(this.state.valor_add);

                    console.log('DEBE: ', debe, 'HABER: ', haber)
                    this.setState({ gridCuentasContables: this.immutablePush(this.state.gridCuentasContables, item),  
                        totalCuentaDebe: formatearNumeroDecimal(debe), totalCuentaHaber: formatearNumeroDecimal(haber)
                    },()=>{
                        this.clearIngCtasBeneficiario(); 
                    })
                }        
            }        
        }else{
            alert("Verifique que tenga una cuenta asociada, valor total del cheque y una observación")
        }
    }

    setObservacion(value){
        if(value){
            //Formateo del nombre de la cuenta
            let temp = value.label.split("(");
            let Nombre = '';
            temp = temp[1].split(")");
            Nombre = temp[0].toString().trim();

            this.setState({observacionCuenta: Nombre})
        }
    }

    guardarEmisionCheque(){
        var errors = "";
        var proceder = true;
        var data = {};

        let fechaProceso = getFechaProcesoPorModulo('07');
        this.setState({contador:this.state.contador+1})
        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }
        
        //Validaciones generales
        if(this.state.num_chq !== "" && this.state.beneficiario!=="" && this.state.concepto!=="" && this.state.valor_chq !== ""){
            //Total valido
            if(desformatearNumeroDecimal(this.state.valor_chq)===0){
                proceder = false;
                errors = errors + '- El valor del cheque debe ser mayor a 0\n'
            }else{

                //Agrupacion de datos generales MovBanco
                data.Localidad = '01';
                data.Status = 'D';
                data.Referencia = this.state.num_chq;  
                data.FechaProceso = formatearFechaMoment_a_String(this.state.fechaProceso);             
                data.Tipo = 'CHE';
                data.Valor = desformatearNumeroDecimal(this.state.valor_chq);
                data.Beneficiario = this.state.beneficiario.toString().trim().toUpperCase();
                data.Concepto = this.state.concepto.toString().trim().toUpperCase();
                data.FechaVencimiento = formatearFechaMoment_a_String(this.state.fechaProceso);                
                data.Cuenta = this.state.catCuentas_sel;
                //Campos moneda
                data.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
                data.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
                data.Usuario = getItemDatosSesion('usuario');
                data.PlanContable = this.state.planVigente;
                //Cta. deporpas
                data.CuentaDeporpas =  this.state.cuentaDeporpas;

                //Evaluar los casos a guardar
                if(this.state.opciones==='P'){
                    
                    data.Opcion = this.state.opciones;
                    data.DetalleFacturasPago = this.state.gridDocsPagar;

                    //NUEVO CAMBIO 17/01/2019
                    data.ActivarCuentas = this.state.gridCuentasContables.length>0?true:false;
                    data.gridCuentasContables = this.state.gridCuentasContables;

                    let debe = Math.round(desformatearNumeroDecimal(this.state.totalCuentaDebe)*100)/100;
                    let haber = Math.round(desformatearNumeroDecimal(this.state.totalCuentaHaber)*100)/100;

                    console.log('DEBE: ', debe, 'HABER: ', haber)
                    if(debe !== haber){
                        errors = errors + ' - El debe y el haber no son iguales'
                        proceder = false;
                    }
                         
                }else if(this.state.opciones==='O'){
                    if(this.state.otras_opciones==='AP'){
                        data.Opcion = this.state.otras_opciones;
                        data.Cod_proveedor = this.state.cod_proveedor;
                        data.cuentaAntProveedor = this.state.cuentaAntProveedor

                        let selected = this.apiAnticipo.getSelectedRows();
                        data.gridAnticipos = selected
                        
                    }else if(this.state.otras_opciones==='AE'){
                        //SET DE DATOS PARA Ant. Empleado

                        data.Opcion = this.state.otras_opciones;
                        let selected = this.apiAnticipoEmpleado.getSelectedRows();
                        data.Cod_empleado = this.state.cod_empleado;
                        data.cuentaAntEmpleado = this.state.cuentaAntEmpleado;
                        data.gridAnticiposEmpleado = selected
                        console.log('DATA A ENVIAR: ', data)
                    }else if(this.state.otras_opciones==='RC'){
                        //SET DE DATOS PARA REP. CAJA.
                        if(this.state.caja_sel !==null){
                            data.Opcion = this.state.otras_opciones;
                            
                            //VALIDACION EXISTA UN TOTAL EN EL MOVIMIENTO SELECCIONADO
                            if(this.state.valorMovCchica === null){
                                proceder = false;
                                errors = errors + '- No se puede continuar, revise: '+this.state.caja_sel.label+', e intentelo nuevamente.\n'
                            }else{
                                let valorCaja = this.state.valorMovCchica
                                //VALIDACION SI LOS VALORES DE CAJACHICA Y EL INGRESADO SON IGUALES
                                if(data.Valor!==valorCaja){
                                    proceder = false;
                                    errors = errors + '- El monto ingresado supera el total de caja chica .\n' ///*+valorCaja+*/
                                }
                                console.log("VALOR CAJA: ",valorCaja ,"VALOR INGRESADO: ",data.Valor)
                                
                            }
                            //CajaID
                            var value = this.state.caja_sel.value.toString().split(" ");
                            data.CajaChica = value[1];
                            data.CuentaCaja = this.state.cuentaCaja_sel;

                        }else{
                            proceder = false;
                            errors = errors + '- Seleccione un movimiento de caja chica\n'
                        }                        
                    }else if(this.state.otras_opciones==='VA'){  
                        let cheque=0; 
                        if(this.state.operacion==='G'){
                             cheque = desformatearNumeroDecimal(this.state.valor_chq)
                        }               
                        let debe  = Math.round((this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'D'))*100)/100;
                        let haber = Math.round((cheque + this.totalizarCuentasContables(this.state.gridCuentasContables, 'Valor', 'H'))*100)/100;
                        
                        console.log('DEBE: ',debe, 'HABER: ',haber )
                        if(debe === haber){
                            //SET DE DATOS PARA VARIOS

                            //Revisar GRID POR IMP
                            if(this.state.importacion_sel!==null){
                                proceder = false;
                                data.Importacion = this.state.importacion_sel.value
                                data.ImportacionGasto = (this.state.catRubroGastoImportacion_sel!==null)?this.state.catRubroGastoImportacion_sel.value : null;
                                this.state.gridCuentasContables.forEach((DATA)=>{
                                    if(DATA.Cuenta===this.state.ctaParametroImp.toString().trim()){
                                        proceder = true;
                                    }
                                })

                                if(proceder === false){
                                    errors = errors + "- Se detecto una importación ingresada, ingrese la cta de provisiones locales de imp"
                                }

                            }else{
                                data.Importacion = null;
                            }

                            data.Opcion = this.state.otras_opciones;
                            data.gridCuentasContables = this.state.gridCuentasContables;

                            if(this.state.operacion === 'M'){
                                data.MovBanco = this.state.movimientoId;
                                data.IdRegAudit= this.props.IdRegAudit;
                            }

                            
                        }else{
                            proceder = false;
                            errors = errors + '- No coincide el total del cheque con el total de las cuentas ingresadas\n'
                        }
                    }
                }
            }
        }else{
            proceder = false;
            errors = errors + '- Revise los campos N° cheque, beneficiario, concepto y valor del cheque antes de continuar...\n'
        }

        console.log('DATA A ENVIAR: \n: ', data)
        //Proceso de grabacion
        if(proceder === true){  
            if(this.state.contador===0){//No ha presionado el boton antes
                let config_request = {
                    method: this.state.operacion==='G'?'POST':'PATCH',
                    url: this.state.operacion==='G'?'/pagos/':'/pagos/'+this.state.movimientoId,
                    data
                }  
                global_axios(config_request)
                .then((response)=> {     
                          
                    alert(response.data.msg);
                    this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.diario,
                        operacion: 'G'},()=>{ //Willy 20191111 ->Se realizo correccion de bloqueo de boton guardar(si presionaban dos veces se guardaba dos veces.)
                            //Proceso de actualizacion de consecutivos de cheques
                            this.cargarCatalogosOtrosCatchResult('BAN-CTASDEP', 'repCuentas').then((r_ctasBancarias)=>{
                                this.setState({catCuentas: r_ctasBancarias}, ()=>{
                                    this.limpiarPantalla('A');
                                    this.setState({catCuentas_sel: data.Cuenta})
                                    this.validarcuentaBancaria(data.Cuenta)
                                    let id = this.state.ult_transaccion
                                    this.setState({movimientoId: id},()=>{
                                        this.getChequesById();
                                    })
                                    
                                    if(this.state.otras_opciones==='AE' ){
                                        this.cargarOrdenPago('EMP')
                                    }else if(this.state.otras_opciones==='AP'){
                                        this.cargarOrdenPago('PRV')
                                    }
                                });
                            })
                        })
                })
                .catch((error)=>{                           
                    alert(error.response?error.response.data.msg:error.message);
                    //Proceso de actualizacion de consecutivos de cheques
                    this.cargarCatalogosOtrosCatchResult('BAN-CTASDEP', 'repCuentas').then((r_ctasBancarias)=>{
                        this.setState({catCuentas: r_ctasBancarias}, ()=>{
                            //this.limpiarPantalla('A');
                            this.setState({catCuentas_sel: data.Cuenta})
                            this.validarcuentaBancaria(data.Cuenta)
                        });
                    })
                });
            }else{
                console.log("ES UN SEGUNDO CLICK")
                this.setState({contador:0})
            }       
        }else{
            this.setState({contador:0})
            alert(errors)
        }
    }

    anularEmisionCheque(){
        var errors = "";
        var proceder = true;

        let msg = window.confirm(`Esta a punto de anular el movimiento: ${this.state.movimientoId}, ¿Continuar?`);
        if(msg){

            //Validación de permisos
            let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
            if(operacion.esValido===false){
                proceder = false;
                errors = errors+operacion.msg
            }

            if(proceder === true){
                global_axios({
                    url: '/pagos/'+this.state.movimientoId,
                    method: 'DELETE',
                    headers: {'idregaudit': this.props.IdRegAudit}
                })
                .then((response)=>{
                    alert(response.data.msg);
                    this.setState({ult_transaccion: response.data.transaction})
                    this.limpiarPantalla('A');
                    this.setState({operacion: 'G'});
                })
                .catch((error)=>{                
                    alert(error.response?error.response.data.msg:error.message);
                    this.limpiarPantalla('A');
                });
            }else{
                alert(errors);
            }
        }
    }

    estadoGuardar(){
        var result = false;
        if(this.state.cuentaDeporpas===null){
            result = true;
        }else if(this.state.operacion === 'M' && this.state.otras_opciones !=='VA'){
            result = true;
        }

        return result;
    }

    clear(){
        this.setState({caja_sel: null, importacion_sel: null,
        cuentaProveedor:'', cod_proveedor: null, cod_empleado: null,
        
        //TEXTBOX
        ident_prov:null, nombreProveedor:'', beneficiario:'',
        valor_chq: '', num_chq: '', concepto: '', cedula: '',

        ident_emp: '', senae: '',
        
        //GRIDS
        gridDocsPendientes: [], gridCuentasContables: [],
        gridDocsPagar: [], gridAnticipos: [], gridAnticiposEmpleado: [],
    
        //AUXILIAR
        valorMovCchica: null, rptCheque:null,
            
        //Totales
        totalCuentaDebe: 0, totalCuentaHaber: 0,
    
        //Diferencia entre Debe&Haber OP: P
        difDebeHaber: 0
        })
    }
    
    cargarCatalogos_OtrosParametrosSimplex(tipo){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    clearIngCtasBeneficiario(){
        this.setState({cuentasBenf_sel: null, valor_add:'',
        optFlujo: [], flujo_sel: null, observacionCuenta: '',
        tipoContable: 'D' , catRubroGastoImportacion_sel :null })
    }
    
    componentDidMount(){ 
        Promise.all([
            this.cargarCatalogos_OtrosParametrosSimplex('COM-PARIMPCTA'),
            cargarCatalogos_Otros('IMP-RUBROGASTO-PAGO'),
            this.cargarObjetos('/secuenciales/MovBanco'),
            cargarCatalogos_Otros('BAN-PARAMCTAEMP'),
            cargarCatalogos_Otros('GEN-PLANVIG'), 
            this.cargarCatalogosOtrosCatchResult('BAN-CTASDEP', 'repCuentas'),
            this.cargarOtrosCatchResult('CAJA-CTAS', 'repCtasCaja'), 
            this.props.generar_LogAuditoriaIngresoForm('0701'), ])
        .then(([ resultParamImpCta,r_catRubroGastoImportacion, secBanco, ctaAnticipo, r_planVigente, r_ctasBancarias, r_repCtasCaja])=>{

            //FECHA DE PROCESO POR MODULO
            let fechaProceso = getFechaProcesoPorModulo('07');
            
            this.setState({ ctaParametroImp: resultParamImpCta[0].Descripcion, catRubroGastoImportacion: r_catRubroGastoImportacion, ult_transaccion: secBanco.codigo -1 ,cuentaAntEmpleado: ctaAnticipo[0].value , 
            planVigente: r_planVigente[0].value, catCuentas: r_ctasBancarias, repCtasCaja: r_repCtasCaja,  
            permiso: this.props.permiso, fechaProceso: moment(fechaProceso, 'DD/MM/YYYY')})
            console.log(this.setState.ctaParametroImp)
        })
        .catch(()=>{
            alert('Parametros de sistema no han sido cargados.')
        })
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0701');
    }

    //FUNCTION AGREGADA PROVEEDOR
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getDCajaChica(value){
        if(this.state.caja_sel!==null){
            var idCajaChica = this.state.caja_sel.value.toString().split(" ");

            this.cargarObjetos('/caja/cajachica/'+idCajaChica[1]).then((cajaResult)=>{
                var acc = 0;
                if(cajaResult.detalle_cajachica!==null){
                    cajaResult.detalle_cajachica.forEach((DCAJA)=>{
                        acc = acc+DCAJA.Valor
                    })
                }

                this.setState({valorMovCchica: Math.round(acc * 100)/100});
            })
        }
    }
    
    impCheque(){
        if(this.state.movimientoId){
            this.cargarObjetos("/reportes/cheques/"+this.state.rptCheque.toString().trim()).then((result)=>{

                if(result !==null){
                    visualizarReporteEnPdf('&rpt='+result.resultSecuencial.CodigoReporte+'&param1='+this.state.movimientoId)
                }else{
                    alert("Reporte no disponible.")
                }
            })
            .catch((error)=>{
                alert('Reporte no ingresado en base Itera')
            })
        }else{
            alert("Carge un movimiento antes de continuar...")
        }
    }

    impRecibo(){
        if(this.state.movimientoId){
            visualizarReporteEnPdf('&rpt=14&param1='+this.state.movimientoId)
        }else{
            alert("Carge un movimiento antes de continuar...")
        }
    }

    importacion_sel(){
        if(this.state.importacion_sel!==null){
            this.cargarObjetos('/importaciongasto?importacion='+this.state.importacion_sel.value+'&senae=true').then((result)=>{              
                this.setState({senae: Math.round(result.senae *100)/100})
            })
        }
    }

    //Validacion para Tipo Cuenta Op. VA
    validarTipoCuenta(){
        let tipo = this.state.tipoContable?this.state.tipoContable.toString().trim().toUpperCase():null; 
        if(tipo!=='D' && tipo!=='H'){
            tipo = 'D'
            this.setState({tipoContable: 'D'});
        }
    }

    render(){
        const invisible = {display: 'none'};
        const visible = {display: 'block'};
        return(
            <ContenedorForm porc_ancho={90}>
             <HeaderForm>
                <TituloForm>Emisión de cheques</TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                <LabelCabecera>N°. diario.: {this.state.num_diario}</LabelCabecera> 
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-sm-2'>
                                <LabelForm>Movimiento:</LabelForm>
                                <InputSearch tipoInput='text' nombre='movimientoId' placeholder='Movimiento' valor={this.state.movimientoId} func_CambiarValor={this.actualizarCamposCheque} 
                                func_BuscarValor={this.getChequesById} func_OnFocus={()=>{this.limpiarPantalla('B')}} maxLength='10'/> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>Cta. Bancaria:</LabelForm>
                                <ReactSelect options={ this.state.catCuentas } value={this.state.catCuentas_sel} func_onChange={(value)=>{this.changeCuentaBancaria(value)}}/>
                            </ContainerCol>
                            <ContainerCol className='col-md-2'>
                                    <LabelSub><Radio name="opciones" type='radio' disabled={false} value='P' onChange={this.actualizarCamposCheque} checked={this.state.opciones==='P'?true:false}/>{' Proveedor  '}</LabelSub>
                                    <LabelSub><Radio name="opciones" type='radio' disabled={false} value='O' onChange={this.actualizarCamposCheque} checked={this.state.opciones==='O'?true:false}/>{" Otros Pagos"}</LabelSub>
                            </ContainerCol>
                            <ContainerCol className='col-sm-3' style={this.state.opciones==="O"?visible:invisible}>
                                <div className='flex-container' >
                                    <div className='flex-item-ajust'>
                                        <LabelSub><Radio name="otras_opciones" type='radio' disabled={false} value='AP' onChange={this.actualizarCamposCheque} checked={this.state.otras_opciones==='AP'?true:false}/>{' Ant. Prov. '}</LabelSub>
                                    </div>
                                    <div className='flex-item-ajust'>
                                        <LabelSub><Radio name="otras_opciones" type='radio' disabled={false} value='AE' onChange={this.actualizarCamposCheque} checked={this.state.otras_opciones==='AE'?true:false}/>{' Ant. Emp. '}</LabelSub>
                                    </div>
                                </div>
                                <div className='flex-container' >
                                    <div className='flex-item-ajust'>
                                        <LabelSub><Radio name="otras_opciones" type='radio' disabled={false} value='RC' onChange={this.actualizarCamposCheque} checked={this.state.otras_opciones==='RC'?true:false}/>{' Rep. Caja '}</LabelSub>
                                    </div>
                                    <div className='flex-item-ajust'>
                                        <LabelSub><Radio name="otras_opciones" type='radio' disabled={false} value='VA' onChange={this.actualizarCamposCheque} checked={this.state.otras_opciones==='VA'?true:false}/>{' Varios '}</LabelSub>
                                    </div>
                                </div>
                            </ContainerCol>
                            <ContainerCol className={this.state.opciones==="O"?'col-sm-2':'col-sm-2 col-md-offset-3'}>
                                <LabelForm>Fecha:</LabelForm>
                                <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={!(this.props.permiteCambioFProceso==='S')} func_onChange={(fechaEscogida)=>{this.setState({fechaProceso: fechaEscogida})}}/>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    {/*OPCION PROVEEDOR*/}
                        {/* FILA ID. PROV. */}
                        <Row style={this.state.opciones==='P' && this.state.cuentaDeporpas!==null?visible:invisible}>
                            <ContainerCol className='col-sm-4 col-sm-offset-2 col-sm-pull-2'>
                                <LabelForm>Id. Prov.:</LabelForm>
                                <ReactSelectAsync value={this.state.ident_prov} disabled={this.state.operacion==='M'?true:false} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.setState({ident_prov: value!==null?value:null})}} func_onBlur={(value)=>{this.getProveedor(value)}}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-6'>
                                <br/>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Valor cheque: </LabelForm>
                                </ContainerCol> 
                                <ContainerCol className='col-sm-9'>
                                    {/* <LabelForm>${this.state.valor_chq}</LabelForm> */}
                                    <InputText ancho='35' text-transform='true' margen_abajo='4' autoComplete='off' name="valor_chq" disabled={this.state.operacion==='M'?true:false} value={this.state.valor_chq} onChange={this.actualizarCamposCheque} onBlur={this.validarMontocheque}/>
                                </ContainerCol>
                            </ContainerCol>
                        </Row>
                        
                        {/*FILA DOCUMENTOS PENDIENTES*/}
                        <Row style={this.state.opciones==='P' && this.state.cuentaDeporpas!==null?visible:invisible}>
                            <ContainerCol className='col-sm-6'>
                                <LabelForm>Documentos pendientes de Pago</LabelForm>
                                <AgGridRender altura='100px' data={this.state.gridDocsPendientes} columnas={this.state.coldefDocsPendientes}
                                gridOptions={this.docsPendientesOptions} onGridReady={this.onGridDocsPendientesReady}/>
                            </ContainerCol>
                            
                            <ContainerCol className='col-sm-6'>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Benficiario: </LabelForm>
                                </ContainerCol> 
                                <ContainerCol className='col-sm-10'>
                                    <InputText ancho='68' mayusculas='true' margen_abajo='8' name="beneficiario" disabled={this.state.operacion==='M'?true:false} value={this.state.beneficiario} onChange={this.actualizarCamposCheque}/>
                                </ContainerCol>
                            </ContainerCol>                            
                            <ContainerCol className='col-sm-6'>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>N° Cheque: </LabelForm>
                                </ContainerCol> 
                                <ContainerCol className='col-sm-10'>
                                    <InputText ancho='35' name="num_chq" value={this.state.num_chq} disabled={this.state.operacion==='M'?true:false} onChange={this.actualizarCamposCheque} onBlur={this.validarNumCheque}/>
                                </ContainerCol>
                            </ContainerCol>
                            <ContainerCol className='col-sm-6'>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Concepto</LabelForm>
                                </ContainerCol> 
                                <ContainerCol className='col-sm-10'>
                                    <InputText ancho='68' mayusculas='true' name="concepto" disabled={this.state.operacion==='M'?true:false} value={this.state.concepto} onChange={this.actualizarCamposCheque} maxLength='80'/>
                                </ContainerCol> 
                            </ContainerCol>
                            <ContainerCol className='col-sm-6'>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Añadir Ctas.</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-1'>
                                    <LabelForm><input type='checkbox' name='activarCuentas' checked={this.state.activarCuentas} 
                                    onChange={this.actualizarCamposCheque}/></LabelForm> 
                                </ContainerCol>

                                <ContainerCol className='col-sm-1'>
                                    <LabelForm>Debe: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>{this.state.totalCuentaDebe}</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-1'>
                                    <LabelForm>Haber: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>{this.state.totalCuentaHaber}</LabelForm>
                                </ContainerCol>
                            </ContainerCol>
                        </Row>
                        
                        {/* GRID PARA CUENTAS */}
                        <Row margen_arriba={5} style={this.state.opciones==='P' && this.state.activarCuentas === true && this.state.cuentaDeporpas!==null?visible:invisible}>
                            <ContainerCol className = 'col-sm-7'>
                                <Row>
                                    <ContainerCol className='col-sm-12'>
                                        <LabelForm>Ctas. contables:</LabelForm>
                                        <AgGridRender altura='100px' data={this.state.gridCuentasContables} columnas={this.state.coldefCuentasContables}
                                        gridOptions={this.CuentasContablesOptions} onGridReady={this.onGridCuentasContablesReady}/>
                                    </ContainerCol>
                                </Row>
                            </ContainerCol>
                            
                            <ContainerCol className = 'col-sm-5'>
                                <Row>
                                    <ContainerCol className = 'col-sm-6'>
                                        <LabelForm>Cuentas Adicionales</LabelForm>
                                    </ContainerCol>
                                </Row>
                                <Row>
                                    <ContainerCol className='col-sm-3' >
                                        <LabelForm>Cta. Cont.:</LabelForm>
                                    </ContainerCol>

                                    <ContainerCol className='col-sm-6'>
                                        <ReactSelectAsync value={this.state.cuentasBenf_sel} func_loadOptions={this.getOptions_CtaContable}
                                        func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.validacionFlujo(value);}}/>                              
                                    </ContainerCol> 

                                    <ContainerCol className='col-sm-1'>
                                        <LabelForm>Tipo:</LabelForm>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2'>
                                        <InputText mayusculas={true} autoComplete='off' name="tipoContable" value={this.state.tipoContable} onChange={this.actualizarCamposCheque} onBlur={this.validarTipoCuenta} maxLength='1'/>
                                    </ContainerCol>
                                </Row>
                                <Row margen_arriba={3}>
                                    <ContainerCol className='col-sm-3' >
                                        <LabelForm>Observación:</LabelForm>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-9' margen_abajo='4'>
                                        <InputText mayusculas={true} autoComplete='off' name="observacionCuenta" disabled={false} value={this.state.observacionCuenta} onChange={this.actualizarCamposCheque} maxLength='80'/>
                                    </ContainerCol>
                                </Row>
                                <Row>
                                    <ContainerCol className='col-sm-3' >
                                        <LabelForm>Flujo:</LabelForm>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-9' margen_abajo='4'>
                                        <ReactSelect disabled={this.state.optFlujo.length>0?false:true} options={ this.state.optFlujo } value={this.state.flujo_sel} func_onChange={(value)=>{this.setState({flujo_sel: value!==null?value:null})}}/>
                                    </ContainerCol>                                    
                                </Row>
                                <Row>
                                    <ContainerCol className='col-sm-3' >
                                        <LabelForm>Valor:</LabelForm>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-6' >
                                        <div className='input-group'>
                                            <InputText  autoComplete='off' name="valor_add" disabled={false} value={this.state.valor_add} onChange={this.actualizarCamposCheque} onBlur={this.validarMontoAdicion} maxLength='8'/>
                                            <span className='input-group-btn'>
                                                <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.addCuenta}><i className='fa fa-chevron-left'/><i className='fa fa-chevron-left'></i> Añadir</ButtonUnion>                
                                            </span>
                                        </div>
                                    </ContainerCol>
                                </Row>
                            </ContainerCol>                            
                        </Row>

                        {/* FACTURAS A PAGAR */}
                        <Row style={this.state.opciones==='P' && this.state.cuentaDeporpas!==null?visible:invisible}>
                            <ContainerCol className='col-sm-9 col-sm-offset-3 col-sm-pull-3'>
                                <br/>
                                <LabelForm>Facturas a pagar</LabelForm>
                                <AgGridRender altura='100px' data={this.state.gridDocsPagar} columnas={this.state.coldefDocsPagar}
                                gridOptions={this.docsPagarOptions} onGridReady={this.onGridDocsPagarReady}/>
                                <div className='flex-container' >
                                    <div className='flex-item'>
                                        <LabelForm>Cta. Proveedor: {this.state.cuentaProveedor}</LabelForm>                                    
                                    </div>
                                </div>     
                            </ContainerCol>
                        </Row>                     
                    {/*OPCION PROVEEDOR*/}

                    {/*OPCION OTROS ANTICIPO PROVEEDOR && EMPLEADO*/}
                        <Row style={this.state.opciones==='O'?( (this.state.otras_opciones==='AP' || this.state.otras_opciones==='AE') && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                            <div className='col-sm-5'>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Número Cheque:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='35' margen_abajo='4'disabled={this.state.operacion==='M'?true:false} name="num_chq" value={this.state.num_chq} onChange={this.actualizarCamposCheque} onBlur={this.validarNumCheque}/>
                                </ContainerCol>
                                <Row style={this.state.opciones==='O'?( (this.state.otras_opciones==='AP' || this.state.otras_opciones==='AE') && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                                    <div className='col-sm-12'>
                                        <ContainerCol className='col-sm-3' style={this.state.opciones==='O'?(this.state.otras_opciones==='AP' && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                                            <LabelForm>Id. Prov.:</LabelForm>
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-9' style={this.state.opciones==='O'?(this.state.otras_opciones==='AP' && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                                            <InputText ancho='105' margen_abajo='4' autoComplete='off' name="cedula" disabled={true} placeholder=' Cédula' value={this.state.cedula} /*onChange={this.changeIdProveedor} onBlur={this.getProveedor}*//>
                                        </ContainerCol>
                                        {/*APARECE EN OPCION AE => */}
                                        <ContainerCol className='col-sm-3' style={this.state.opciones==='O'?(this.state.otras_opciones==='AE' && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                                            <LabelForm>Id. Emp.:</LabelForm>
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-9' style={this.state.opciones==='O'?(this.state.otras_opciones==='AE' && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                                            <InputText ancho='105' margen_abajo='4' autoComplete='off' name="ident_emp" disabled={true} placeholder='Empleado' value={this.state.ident_emp} onChange={this.changeIdProveedor} onBlur={this.getEmpleado}/>
                                        </ContainerCol>
                                         {/*APARECE EN OPCION AE => */}
                                        <ContainerCol className='col-sm-3'>
                                            <LabelForm>Beneficiario:</LabelForm>
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-9'>
                                            <InputText ancho='105' mayusculas='true' margen_abajo='4' disabled={this.state.operacion==='M'?true:false} name="beneficiario" value={this.state.beneficiario} onChange={this.actualizarCamposCheque}/>
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-3'>
                                            <LabelForm>Concepto</LabelForm>
                                        </ContainerCol> 
                                        <ContainerCol className='col-sm-9'>
                                            <InputText ancho='105' margen_abajo='4' name="concepto" disabled={this.state.operacion==='M'?true:false} value={this.state.concepto} onChange={this.actualizarCamposCheque} maxLength='80'/>
                                        </ContainerCol> 
                                    </div>
                                </Row>
                            </div>                         
                            <div className='col-sm-7' style={this.state.opciones==='O'?(this.state.otras_opciones==='AP' && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                                <LabelForm>Anticipos:</LabelForm>
                                <AgGridRender altura='150px' data={this.state.gridAnticipos} columnas={this.state.coldefAnticipos}
                                gridOptions={this.anticiposOptions} onGridReady={this.onGridAnticiposReady}/>
                            </div>
                            {/*APARECE EN OPCION AE => */}
                            <div className='col-sm-7' style={this.state.opciones==='O'?(this.state.otras_opciones==='AE' && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                                <LabelForm>Anticipos:</LabelForm>
                                <AgGridRender altura='150px' data={this.state.gridAnticiposEmpleado} columnas={this.state.coldefAnticiposEmpleado}
                                gridOptions={this.anticiposEmpleadoOptions} onGridReady={this.onGridAnticiposEmpleadosReady}/>
                            </div>      
                            {/*APARECE EN OPCION AE => */}         
                        </Row>
                        <Row style={this.state.opciones==='O'?( (this.state.otras_opciones==='AP'  || this.state.otras_opciones==='AE') && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                            <div className='col-sm-6 col-sm-offset-6 col-sm-pull-6'>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Valor Cheque:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <LabelForm>${this.state.valor_chq}</LabelForm>
                                </ContainerCol>                     
                            </div>
                        </Row>   
                    {/*OPCION OTROS ANTICIPO PROVEEDOR && EMPLEADO*/}
           
                    {/*OPCION OTROS -> REP.CAJACHICA*/}
                        <Row style={this.state.opciones==='O'?(this.state.otras_opciones==='RC' && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                            <div className='col-sm-6 col-sm-offset-6 col-sm-pull-6'>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Caja.:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-7 col-sm-offset-2 col-sm-pull-2'>                                
                                    <ReactSelectAsync value={this.state.caja_sel} func_loadOptions={this.getOptions_CajaChica} 
                                    func_onChange={(value)=>{this.changeCaja(value)}} disabled={this.state.operacion==='M'?true:false} func_onBlur={(value=>{this.getDCajaChica(value)})}/>                           
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>N° cheque:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='35' margen_arriba='4' margen_abajo='4' disabled={this.state.operacion==='M'?true:false} name="num_chq" value={this.state.num_chq} onChange={this.actualizarCamposCheque} onBlur={this.validarNumCheque}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Beneficiario:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='79' mayusculas='true' margen_abajo='4' disabled={this.state.operacion==='M'?true:false} name="beneficiario" value={this.state.beneficiario} onChange={this.actualizarCamposCheque}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Concepto</LabelForm>
                                </ContainerCol> 
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='79' mayusculas='true' margen_abajo='4' disabled={this.state.operacion==='M'?true:false} name="concepto" value={this.state.concepto} onChange={this.actualizarCamposCheque} maxLength='80'/>
                                </ContainerCol>                              
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Valor Cheque:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='35' margen_abajo='4' disabled={this.state.operacion==='M'?true:false} autoComplete='off' name="valor_chq" value={this.state.valor_chq} onChange={this.actualizarCamposCheque} onBlur={this.validarMontocheque}/>
                                </ContainerCol>                                                               
                            </div>
                        </Row>
                    {/*OPCION OTROS -> REP.CAJACHICA*/}

                    {/*OPCION OTROS -> VARIOS*/}
                        <Row style={this.state.opciones==='O'?(this.state.otras_opciones==='VA' && this.state.cuentaDeporpas!==null?visible:invisible):invisible}>
                            <div className='col-sm-5'>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>N° cheque:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='35' text-transform='true' margen_abajo='4' name="num_chq" disabled={this.state.operacion==='M'?true:false} value={this.state.num_chq} onChange={this.actualizarCamposCheque} onBlur={this.validarNumCheque}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Beneficiario:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='64' mayusculas='true' text-transform='true' margen_abajo='4'  name="beneficiario" disabled={this.state.operacion==='M'?true:false} value={this.state.beneficiario} onChange={this.actualizarCamposCheque}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Concepto</LabelForm>
                                </ContainerCol> 
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='64' mayusculas='true' text-transform='true' margen_abajo='4' name="concepto"  disabled={this.state.operacion==='M'?true:false} value={this.state.concepto} onChange={this.actualizarCamposCheque} maxLength='80'/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Valor Cheque:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='35' text-transform='true' margen_abajo='4' autoComplete='off' name="valor_chq" disabled={this.state.operacion==='M'?true:false} value={this.state.valor_chq} onChange={this.actualizarCamposCheque} onBlur={this.validarMontocheque}/>
                                </ContainerCol>                             
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Importación:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-6 col-sm-offset-4 col-sm-pull-3'>
                                    <ReactSelectAsync value={this.state.importacion_sel} disabled={this.state.operacion==='M'?true:false} func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.setState({importacion_sel: value!==null?value:null})}} func_onBlur={this.importacion_sel}/>
                                </ContainerCol> 
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Valor Senae: </LabelForm>
                                </ContainerCol> 
                                <ContainerCol className='col-sm-9'>
                                    <InputText ancho='64' text-transform='true' margen_arriba='4' name="senae"  disabled={true} value={this.state.senae} onChange={this.actualizarCamposCheque} maxLength='80'/>
                                </ContainerCol>
                            </div>
                            <div className='col-sm-7'>
                                <ContainerCol className='col-sm-3' >
                                    <LabelForm>Cta. Cont.:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-7' margen_abajo='4'>
                                    <ReactSelectAsync value={this.state.cuentasBenf_sel} func_loadOptions={this.getOptions_CtaContable}
                                    func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.validacionFlujo(value);this.handleHabilitaGasto(value);}}
                                    func_OnFocus = {()=>{this.setState({catRubroGastoImportacion_sel: null})}}/>
                                </ContainerCol> 

                                <ContainerCol className='col-sm-1'>
                                    <LabelForm>Tipo:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-1'>
                                    <InputText mayusculas={true} autoComplete='off' name="tipoContable" value={this.state.tipoContable} onChange={this.actualizarCamposCheque} onBlur={this.validarTipoCuenta} maxLength='1'/>
                                </ContainerCol>

                                <ContainerCol className='col-sm-3' >
                                    <LabelForm>Observación:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-7 col-sm-offset-2 col-sm-pull-2' margen_abajo='4'>
                                    <InputText mayusculas={true} autoComplete='off' name="observacionCuenta" disabled={false} value={this.state.observacionCuenta} onChange={this.actualizarCamposCheque} maxLength='80'/>
                                </ContainerCol>

                                <ContainerCol className='col-sm-2 ' >
                                    <LabelForm>Flujo:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-7 col-sm-offset-2 col-sm-pull-1' margen_abajo='4'>
                                    <ReactSelect disabled={this.state.optFlujo.length>0?false:true} options={ this.state.optFlujo } value={this.state.flujo_sel} func_onChange={(value)=>{this.setState({flujo_sel: value!==null?value:null})}}/>
                                </ContainerCol>

                                <ContainerCol className='col-sm-3' >
                                    <LabelForm>Valor:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-4' >
                                    <div className='input-group'>
                                        <InputText  autoComplete='off' name="valor_add" disabled={false} value={this.state.valor_add} onChange={this.actualizarCamposCheque} onBlur={this.validarMontoAdicion} maxLength='9'/>
                                        <span className='input-group-btn'>
                                            <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.addCuenta}><i className='fa fa-plus'></i>Añadir</ButtonUnion>                
                                        </span>
                                    </div>
                                </ContainerCol>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Cod. Gasto:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                        <ReactSelect options={ this.state.catRubroGastoImportacion } disabled = {this.state.deshabilitaGasto} value={this.state.catRubroGastoImportacion_sel} 
                                        func_onChange={(value)=>{this.setState({catRubroGastoImportacion_sel: value!==null?value:null})}}/>                                    
                                </ContainerCol>
                                <ContainerCol margen_arriba='10' className='col-sm-12'>
                                    <Row>   
                                        <ContainerCol className='col-sm-3'>
                                            <LabelForm>Ctas. contables:</LabelForm>
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-1'>
                                            <LabelForm>Debe: </LabelForm>
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-2'>
                                            <LabelForm>{this.state.totalCuentaDebe}</LabelForm>
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-1'>
                                            <LabelForm>Haber: </LabelForm>
                                        </ContainerCol>
                                        <ContainerCol className='col-sm-2'>
                                            <LabelForm>{this.state.totalCuentaHaber}</LabelForm>
                                        </ContainerCol>
                                    </Row>
                                    <AgGridRender altura='100px' data={this.state.gridCuentasContables} columnas={this.state.coldefCuentasContables}
                                    gridOptions={this.CuentasContablesOptions} onGridReady={this.onGridCuentasContablesReady}/>
                                </ContainerCol>
                                                               
                            </div>
                        </Row>
                    {/*OPCION OTROS -> VARIOS*/}

                    <Row>
                        <div className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.estadoGuardar()} onClick={this.guardarEmisionCheque}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('A')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                <button type='button' className='btn btn-danger btn-sm' disabled={this.state.estado==='G'?false:true} onClick={this.anularEmisionCheque}><i className='fa fa-window-close  fa-lg'/> Anular</button>
                                <button type='button' className='btn btn-default btn-sm' disabled={this.state.rptCheque!==null&&this.state.operacion==='M'?false:true} onClick={this.impCheque}><i className="fa fa-print fa-lg" aria-hidden="true"/> Cheque</button>
                                <button type='button' className='btn btn-default btn-sm' disabled={this.state.operacion==='M'&& this.state.movimientoId!==''?false:true} onClick={this.impRecibo}><i className="fa fa-print fa-lg" aria-hidden="true"/> Recibo</button>                      
                            </div>
                        </div>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            departamento : state.sesion.valoresSesionForm.Departamento,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias}
  });
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormBanco01);